import { FieldFilter } from "@directus/types";

export class FilterSchemaCreateException extends Error {
  constructor(reason: string, filter: FieldFilter) {
    super(`[filter-schema-creator]: ${reason}. Filter data: ${JSON.stringify(filter)}`);
  }
}

